import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDataService } from './shared/inmemory-db/inmemory-db.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { Utils } from './shared/utils';
import { NgxSpinnerModule } from 'ngx-spinner';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import {
	NgbCalendar,
	NgbDateAdapter,
	NgbDateParserFormatter,
	NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { NgbCustomDateParserFormatter } from './shared/ngb-custom-date-parser-formatter';
import { NgxPaginationModule } from 'ngx-pagination';
import { ColorPickerModule } from 'ngx-color-picker';
import { AuthInterceptor } from './shared/services/auth.interceptor';

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		SharedModule,
		HttpClientModule,
		BrowserAnimationsModule,
		InMemoryWebApiModule.forRoot(InMemoryDataService, {
			passThruUnknownUrl: true,
		}),
		AppRoutingModule,
		NgxSpinnerModule,
		FormsModule,
		ReactiveFormsModule,
		NgSelectModule,
		NgxPaginationModule,
		ColorPickerModule,
	],
	providers: [
		Utils,
		{
			provide: NgbDateParserFormatter,
			useValue: new NgbCustomDateParserFormatter('DD/MM/YYYY'), // <== formato!
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
	],
	bootstrap: [AppComponent],
	exports: [ColorPickerModule],
})
export class AppModule { }
